import { render } from "./appheader2.vue?vue&type=template&id=7d9b7bb1&scoped=true"
import script from "./appheader2.vue?vue&type=script&lang=js"
export * from "./appheader2.vue?vue&type=script&lang=js"

import "./appheader2.vue?vue&type=style&index=0&id=7d9b7bb1&lang=scss&scoped=true"

import exportComponent from "/Users/vee/Desktop/git/web/bitcoooPcWebsite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d9b7bb1"]])

export default __exports__